/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfo_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_user">;
    readonly " $refType": "PdpSharedShippingInfo_user";
};
export type PdpSharedShippingInfo_user$data = PdpSharedShippingInfo_user;
export type PdpSharedShippingInfo_user$key = {
    readonly " $data"?: PdpSharedShippingInfo_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfo_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user",
      "args": null
    }
  ]
};
(node as any).hash = '51591383856c8c358c49c964288cdc6c';
export default node;
